export class AppConstants {
    public static DATE_FORMAT = 'd MMM yyyy';
    public static API_DATE_FORMAT = 'yyyy-MM-dd';
    public static DATE_TIME_FORMAT = 'd MMM yyyy hh:mm a';
    public static REFERRAL_CODE_MIN_LEGTH = 5;
    public static SDC = 'SHORT_DELIVIERY_CLAIM';
    public static PDC = 'PRICE_DIFFERENCE_CLAIM';
    public static ALLOWED_USER_TYPES: Record<string, string> = {
        staff: 'Staff User',
        wholesaler: 'Wholesaler',
        supplier: 'Supplier',
    };
}
